import { ChangeEvent, useCallback, useMemo, useState } from 'react';
import {
  JobCountDetailResponse,
  JobCountResponse,
  SavedSearchResponse,
} from '@doda/api-client/aspida/@types';
import { findJobCount } from 'components/IndustryModal/logics/createIndustryDisplayData';
import { JobOfferKindListType } from 'types/kodawari';
import { FeaturedSearchConditionQuery } from 'components/SearchSideBar/types';
import { createInitialJobOfferKindList } from '../../logics/jobOfferKind/createInitialJobOfferKindList';

interface ArgumentType {
  savedSearchCondition?: SavedSearchResponse | undefined;
  featuredSearchCondition?: FeaturedSearchConditionQuery | undefined;
  query: string | undefined;
  jobCountData: JobCountResponse;
}

/**
 * 応募方法に関するhooks
 * @param args
 * @returns 表示用配列と更新処理
 */
export const useJobOfferKind = (args: ArgumentType) => {
  const [jobOfferKindList, setJobOfferKindList] = useState<
    JobOfferKindListType[]
  >(createInitialJobOfferKindList(args));

  const selectedJobOfferKindList = useMemo(() => {
    return jobOfferKindList
      .filter(({ isChecked }) => isChecked)
      .map(({ value }) => value)
      .at(0);
  }, [jobOfferKindList]);

  // チェック状態更新処理
  const updateIsCheckedJobOfferKindList = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const checkedList = jobOfferKindList.map((item) => {
        if (item.value !== event.target.value)
          return {
            ...item,
            isChecked: false,
          };

        return {
          ...item,
          isChecked: event.target.checked,
        };
      });

      setJobOfferKindList(checkedList);

      return checkedList
        .filter(({ isChecked }) => isChecked)
        .map(({ value }) => value)
        .at(0);
    },
    [jobOfferKindList]
  );

  // 求人件数更新処理
  const updateJobOfferKindListJobCount = useCallback(
    (requirementsJobCountList: JobCountDetailResponse[] | undefined) => {
      setJobOfferKindList((pre) =>
        pre.map((item) => ({
          ...item,
          jobCount: findJobCount(requirementsJobCountList, item.value),
        }))
      );
    },
    []
  );

  return {
    jobOfferKindList,
    selectedJobOfferKindList,
    updateIsCheckedJobOfferKindList,
    updateJobOfferKindListJobCount,
  };
};
